import script from "./DrawerNavItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./DrawerNavItem.vue?vue&type=script&lang=ts&setup=true"

import "./DrawerNavItem.vue?vue&type=style&index=0&id=7d1153b7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d1153b7"]])

export default __exports__